import { GameService } from '~/services';
import { createIncrementalOptions } from '~/stores/lib/createIncrementalQuery';

const service = new GameService();

export const gameQueries = {
  list: createIncrementalOptions('game', (args) => service.readAll(args)),
};
